"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getIndexBefore_1 = __importDefault(require("./getIndexBefore"));

function getNextCharacterIndex(editorState, currIndex) {
  var index = getIndexBefore_1.default(editorState.list.value, currIndex, function (ch) {
    return ch.type == null;
  });

  if (index != null) {
    return index;
  } else {
    return currIndex;
  }
}

exports.default = getNextCharacterIndex;